import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DocumentTemplate } from '../services/document-template-api-caller.service';

@Component({
  selector: 'app-config-template',
  templateUrl: './config-template.component.html',
  styleUrl: './config-template.component.scss'
})
export class ConfigTemplateComponent {
  public form: FormGroup;

  constructor(public dialogRef: MatDialogRef<ConfigTemplateComponent>, private fb: FormBuilder, @Inject(MAT_DIALOG_DATA) public data: DocumentTemplate) {
    console.log(data);
  }

  ngOnInit() {
    this.form = this.fb.group({
      name: [this.data?.name || '', [Validators.required]], 
      description: [this.data?.description || '', [Validators.required]],
      size: [this.data.jsonConfig?.size || 0, [Validators.required]],
      orientation: [this.data.jsonConfig?.orientation || 0, [Validators.required]],
    });
  }

  public submit() {
    this.data.name = this.form.get('name')?.value;
    this.data.description = this.form.get('description')?.value;
    this.data.jsonConfig.orientation = Number(this.form.get('orientation')?.value);
    this.data.jsonConfig.size = Number(this.form.get('size')?.value);

    this.dialogRef.close(this.data);
  }

}